/**
 * localstorage 工具
 */
 const getLocalStorage = (key) =>{
    let value = localStorage.getItem(key);
    if (value) {
        return JSON.parse(value);
    } else {
        return null
    }
}

const setLocalStorage = (key,value)=>{
    localStorage.setItem(key, JSON.stringify(value));
}

const removeLocalStorage = (key)=>{
    localStorage.removeItem(key);
}

export default{
    getLocalStorage,
    setLocalStorage,
    removeLocalStorage
}


// WEBPACK FOOTER //
// ./src/util/storage.js